// Copyright (c) Hamilton Manufacturing Corp.
import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import styled from 'styled-components';
import AccountForm from '../../_common/AccountForm';
import { useGlobalState } from '../../_common/globalState/GlobalStateProvider';
import Card from '../Card';
import Button from '../../_common/form/Button';

const Wrapper = styled.div`
`
const Col = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`

const SignUp = ({ ...props }) => {
    const {
        state: {
            active_user,
        },
    } = useGlobalState();

    // 'form' -> 'created' (account made, signing in) -> handled by redirect,
    // or 'loginError' if the automatic sign in didn't go through.
    const [phase, setPhase] = useState('form');

    if (active_user.isLoggedIn) {
        return <Navigate to='/' replace />;
    }

    return (
        <Wrapper>
            <Card>
                {phase === 'form' && (
                    <>
                        <Col>
                            <span>Welcome!</span>
                            <span>Please complete the following fields</span>
                        </Col>
                        <AccountForm
                            password
                            referral
                            signup
                            fullWidthSubmit
                            onAccountCreated={() => setPhase('created')}
                            onAutoLoginError={() => setPhase('loginError')}
                        />
                        <Button to='/'>Go Back</Button>
                    </>
                )}
                {phase === 'created' && (
                    <Col>
                        <span>Account created!</span>
                        <span>Signing you in&hellip;</span>
                    </Col>
                )}
                {phase === 'loginError' && (
                    <Col>
                        <span>Your account was created.</span>
                        <span>Please log in to continue.</span>
                        <Button to='/'>Go to Log In</Button>
                    </Col>
                )}
            </Card>
        </Wrapper>
    );
}

export default SignUp;